import service from "@/utils/request";

export function getOrderPackageList(data) {
    return service({
        url: "/orderPackage/queryPage",
        method: "post",
        data,
    });
}

export function changeOrderPackageType(data) {
    return service({
        url: "/orderPackage/changeStatus",
        method: "post",
        data,
    });
}

